function IconQuoteEnd({ fill, stroke }) {
  return (
    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6077 5.34818C9.00263 5.74945 7.74934 7.00274 7.34806 8.60785L4 22.0001L9.39225 20.652C10.9974 20.2508 12.2507 18.9975 12.6519 17.3924L16 4L10.6077 5.34818Z" fill={fill} />
      <path d="M7.60775 2.34818C6.00263 2.74945 4.74934 4.00274 4.34806 5.60785L1 19.0001L6.39225 17.652C7.99737 17.2508 9.25065 15.9975 9.65193 14.3924L13 1L7.60775 2.34818Z" stroke={stroke} />
    </svg>
  )
}

export default IconQuoteEnd